import { FunctionComponent } from "react";
import { useStatusFilterContext } from "./StatusFilter";
import { cva } from "class-variance-authority";

export interface StatusFilterButtonProps {
  className?: string;
  label: string;
  statValue?: string | number;
  id: string;
  selected?: boolean;
  loading?: boolean;
}

const statusCva = cva(
  [
    "px-2 py-3 w-24 sm:px-3 transition-all sm:w-28 flex scale flex-col   shrink-0 justify-between rounded-lg",
  ],
  {
    variants: {
      selected: {
        true: ["bg-primary-500 text-white"],
        false: ["outline outline-1 sm:outline-2  outline-gray-300"],
      },
    },
  },
);

const textCva = cva("", {
  variants: {
    type: {
      stat: ["h-6 text-lg font-semibold"],
      label: ["text-xs sm:text-sm"],
    },
    selected: {
      true: ["text-white"],
      false: [],
    },
  },
  compoundVariants: [
    { type: "stat", selected: true, className: "" },
    { type: "label", selected: false, className: "text-gray-800" },
  ],
});

/**
 *
 */
export const StatusFilterButton: FunctionComponent<StatusFilterButtonProps> = ({
  className,
  label,
  selected,
  statValue,
  id,
  loading,
}) => {
  const { toggle, selectedId } = useStatusFilterContext();
  selected = selected == null ? selectedId == id : selected;
  // const css = cx(
  //   className,
  //   "p-2 w-24 sm:p-3 sm:w-28 flex scale flex-col border-0  shadow shrink-0 justify-center rounded-lg ",
  //   selected && "ring-blue-500 ring-2",
  //   !selected && "ring-gray-300 ring-1"
  // );
  const ariaLabel = label + " customers";
  return (
    <button
      className={statusCva({ selected, className })}
      onClick={() => toggle(id)}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
    >
      <div className={textCva({ type: "label", selected })}>{label}</div>
      <div className={textCva({ type: "stat", selected })}>
        {loading ? "–" : statValue}
      </div>
    </button>
  );
};

export default StatusFilterButton;
